import React from 'react';
import Modal from 'components/commons/modal/Modal2';
import Icon from 'components/commons/icon/Icon';

export const AccountAlignmentModal = ({
  hideModal,
  isShowModal,
}: {
  isShowModal: boolean;
  hideModal: () => void;
}): React.ReactElement => {
  return (
    <Modal isShow={isShowModal} close={hideModal} closeOnClickOutsideWindow>
      <div className="p-4">
        <div className="flex flex-row">
          <div className="text-base font-bold">資産情報取得中です</div>
          <div
            className="icon-close ml-auto text-gray-500 text-2xl cursor-pointer"
            onClick={hideModal}
          />
        </div>
        <div className="mt-2 text-sm">
          資産情報取得中です。完了するまでお待ちください。
        </div>

        <div className="mt-4 text-sm">
          下記の場合は、口座連携までにお時間がかかる場合があります。
          <div>・土日・祝日に初回連携をした場合</div>
          <div>・証券会社がメンテナンス中の場合</div>
          <div>・ネットが繫りにくい状態</div>
          <div>・予期せぬエラーが発生した場合</div>
        </div>
        <div className="mt-4 flex items-baseline text-link text-xs">
          <a
            href={`https://support.minkabu.jp/hc/ja/articles/14228112171417-%E3%83%87%E3%83%BC%E3%82%BF%E6%9B%B4%E6%96%B0%E3%81%AE%E3%82%BF%E3%82%A4%E3%83%9F%E3%83%B3%E3%82%B0`}
            target="_blank"
            rel="noopener noreferrer">
            データ更新のタイミング
          </a>
          <Icon name="external-link" className="ml-1 text-sm" />
        </div>
        <div
          onClick={hideModal}
          className="flex justify-center text-gray-500 m-1 p-2 text-base cursor-pointer">
          閉じる
        </div>
      </div>
    </Modal>
  );
};
